import React from "react";
import { dateRange, initials } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function PhotoHeaderTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden" data-testid="resume-live-preview">
      <div className="p-6 flex items-center gap-4" style={{ backgroundColor: accent }}>
        <div className="w-14 h-14 rounded-full bg-white/25 flex items-center justify-center text-white font-bold text-lg shrink-0">{initials(draft.full_name)}</div>
        <div>
          <h1 className="text-xl font-bold text-white">{draft.full_name || "Your Name"}</h1>
          <p className="text-white/85 text-xs mt-0.5">{draft.target_role}</p>
          <p className="text-white/70 text-[11px] mt-0.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
        </div>
      </div>
      <div className="p-6 grid grid-cols-[38%_62%] gap-5">
        <div>
          {draft.skills.length > 0 && (
            <div>
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Skills</h2>
              <ul className="mt-1.5 space-y-1">{draft.skills.map((sk) => <li key={sk} className="text-slate-700 text-[11px]">{sk}</li>)}</ul>
            </div>
          )}
          {draft.education.length > 0 && (
            <div className="mt-4">
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
              {draft.education.map((ed, i) => <p key={i} className="text-slate-700 text-[11px] mt-1.5">{ed.degree} {ed.field}<br />{ed.school}</p>)}
            </div>
          )}
        </div>
        <div>
          {draft.summary && (
            <div>
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Summary</h2>
              <p className="text-slate-700 mt-1">{draft.summary}</p>
            </div>
          )}
          {draft.experience.length > 0 && (
            <div className="mt-4">
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
              {draft.experience.map((e, i) => (
                <div key={i} className="mt-2">
                  <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                  <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
                </div>
              ))}
            </div>
          )}
          <ExtraResumeSections draft={draft} accent={accent} />
        </div>
      </div>
    </div>
  );
}
